const translations = {
  "datepicker.header.title.date": "Date",
  "datepicker.header.title.range": "From - to",
  "datepicker.select.last7": "Last 7 days",
  "datepicker.select.last30": "Last 30 days",
  "datepicker.select.last90": "Last 90 days",
  "datepicker.select.this-month": "This month",
  "datepicker.select.last-month": "Last month",
  "datepicker.select.all": "All",
  "datepicker.select.custom": "Custom",
}

export default translations;